<template>
	<div
		v-if="($props.errors && $props.errors.length) || $props.errorMessage"
		class="px-2 py-1 text-sm text-white bg-red-600 rounded"
	>
		<span v-if="$props.errors && $props.errors.length">{{ errors[0] }}</span>
	</div>
</template>

<script>
export default {
	name: 'Error',
	props: {
		errors: {
			type: Array,
			default: [],
		},
	},
	methods: {},
}
</script>
<style lang="postcss" scoped></style>
